import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "fileInput",
    "categoricalOption",
    "categoricalCheckbox",
    "progress",
    "progressBar",
    "status",
    "submitButton",
  ]

  connect() {
    this.wasCategoricalVisible = false
    this.updateCategoricalOption()
  }

  updateCategoricalOption() {
    if (!this.hasCategoricalOptionTarget || !this.hasCategoricalCheckboxTarget) return

    const filename = this.hasFileInputTarget && this.fileInputTarget.files.length > 0
      ? this.fileInputTarget.files[0].name.toLowerCase()
      : ""
    const isRaster = [".tif", ".tiff", ".geotiff"].some(ext => filename.endsWith(ext))

    this.categoricalOptionTarget.classList.toggle("d-none", !isRaster)
    this.categoricalOptionTarget.classList.remove("team-data-attention-pulse")

    if (isRaster && !this.wasCategoricalVisible) {
      // Force reflow so the animation reliably restarts when the option first appears.
      void this.categoricalOptionTarget.offsetWidth
      this.categoricalOptionTarget.classList.add("team-data-attention-pulse")
    }

    if (!isRaster) this.categoricalCheckboxTarget.checked = false
    this.wasCategoricalVisible = isRaster
  }

  start(event) {
    this.progressTarget.classList.remove("d-none")
    this.progressBarTarget.style.width = "0%"
    this.statusTarget.innerText = ""
    this.progressBarTarget.classList.add("progress-bar-animated")
    this.progressBarTarget.classList.remove("bg-danger")
  }

  progress(event) {
    this.progressBarTarget.style.width = `${event.detail.progress}%`
  }

  error(event) {
    this.progressBarTarget.classList.remove("progress-bar-animated")
    this.progressBarTarget.classList.add("bg-danger")
    this.progressBarTarget.style.width = "100%"
    this.statusTarget.innerText = event.detail.error
    this.submitButtonTarget.disabled = false
    event.preventDefault()
  }
}
